/**
 * スリープ関数(非同期利用版)
 * @param {*} msec
 */
export const sleep = (msec) =>
  new Promise((resolve) => setTimeout(resolve, msec));
